"use client";

import clsx from 'clsx';
import * as React from 'react';
import { useContext } from 'react';
import FormContext from './FormContext.js';
import { useBootstrapPrefix } from './ThemeProvider.js';
import { jsx as _jsx } from "react/jsx-runtime";
const FormCheckInput = /*#__PURE__*/React.forwardRef(({
  id,
  bsPrefix,
  className,
  type = 'checkbox',
  isValid = false,
  isInvalid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'input',
  ...props
}, ref) => {
  const {
    controlId
  } = useContext(FormContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-check-input');
  return /*#__PURE__*/_jsx(Component, {
    ...props,
    ref: ref,
    type: type,
    id: id || controlId,
    className: clsx(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  });
});
FormCheckInput.displayName = 'FormCheckInput';
export default FormCheckInput;